import { type LoaderFunctionArgs, json } from '@remix-run/node'
import Markdown from 'react-markdown'
import { termsEn, termsNl } from '#app/constants/markdown/terms.ts'
import { MenuContainer } from '#app/features/menu/container.tsx'
import { useCurrentLanguage } from '#app/hooks/use-current-language.tsx'
import { getUserId } from '#app/utils/auth.server.ts'
import { mixpanel } from '#app/utils/mixpanel.server.ts'
import { getLanguageIdFromPathname } from '#server/utils/getLanguageIdFromPathname.ts'

export async function loader({ request }: LoaderFunctionArgs) {
	const languageId = getLanguageIdFromPathname(request)
	const userId = await getUserId(request)

	mixpanel.track(`PageView: ${languageId} - Home Landingpage`, {
		distinct_id: userId ?? 'anonymous',
		timeStamp: new Date().toISOString(),
	})

	return json({} as any)
}

const getTerms = (language: string) => {
	switch (language) {
		case 'en':
			return termsEn
		case 'nl':
			return termsNl
		default:
			return termsEn
	}
}

export default function TermsOfServiceRoute() {
	const currentLanguage = useCurrentLanguage()
	const terms = getTerms(currentLanguage)

	return (
		<MenuContainer showLogo showFooter showLanguageForm>
			<div className="px-6 py-32 lg:px-8">
				<div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">
					<Markdown className="lg:prose-md prose">{terms}</Markdown>
				</div>
			</div>
		</MenuContainer>
	)
}
